<span>{{ Title }}</span>
<div class="form-image-div" (click)="openFileDialogHandler()">
    <input type="file" #image_input accept='image/*' (change)="preview(image_input.files)" class="custom-file-input" />
    <img src="{{ Image ? Image : DefaultImage }}" style="width: 40%;" />
</div>